module.exports = __webpack_public_path__ + "static/EricDodson-a3943423b172031c9eab80d5b44cf911.jpg";